import * as React from "react";
import {CenteredColumn as ShadcnCenteredColumn} from "../z70-shadcn/components/CenteredColumn";

export function CenteredColumn({children, maxWidth, sidePadding, backgroundColor}) {
    return (
        <ShadcnCenteredColumn 
            maxWidth={maxWidth}
            sidePadding={sidePadding}
            backgroundColor={backgroundColor}
        >
            {children}
        </ShadcnCenteredColumn>
    );
}